export function flattenCatalogVitrineShelves(shelves = []) {
  return shelves.flatMap((shelf) => shelf.items || []);
}
